<template>
  <span class="circle" :class="color"></span>
</template>

<script>
export default {
  name: 'BadgeCircle',
  props: {
    color: {
      type: String,
    },
  }
}
</script>

<style lang="scss" scoped>
.circle {
  display: inline-block;
  width: 0.625rem;
  height: 0.625rem;
  border-radius: 50%;
  background-color: #8D8D8D;

  &.green {
    background-color: #16A34A;
  }

  &.green2 {
    background-color: #228b22;
  }

  &.red {
    background-color: #CA2222;
  }

  &.yellow {
    background-color: #FABF10;
  }

  &.blue {
    background-color: #1C2D5A;
  }
}
</style>